

/** A BIC as typed (spaces and small letters allowed) in its standard form in capitals, or null when it is not 8 or 11 letters and digits in the bank / country / place (/ branch) pattern. */
export function verifyBic(typed: string): string | null {
  const bic = typed.replace(/\s/g, "").toUpperCase();
  return /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(bic) ? bic : null;
}

/** The length of an IBAN by country (the 2 letters it starts with), for the countries that use them. */
const IBAN_LENGTHS: Readonly<Record<string, number>> = {
  AD: 24, AE: 23, AL: 28, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29, BY: 28, CH: 21, CR: 22, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, EG: 29, ES: 24, FI: 18, FO: 18, FR: 27, GB: 22, GE: 22, GI: 23, GL: 18,
  GR: 27, GT: 28, HR: 21, HU: 28, IE: 22, IL: 23, IQ: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28, LC: 32, LI: 21, LT: 20, LU: 20, LV: 21, LY: 25, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27, MT: 31, MU: 30, NL: 18, NO: 15,
  PK: 24, PL: 28, PS: 29, PT: 25, QA: 29, RO: 24, RS: 22, SA: 24, SC: 31, SE: 24, SI: 19, SK: 24, SM: 27, ST: 25, SV: 28, TL: 23, TN: 24, TR: 26, UA: 29, VA: 22, VG: 24, XK: 20,
};

/** An IBAN as typed (spaces, dashes and small letters allowed) in its standard form without spaces, or null when it is not valid: it must start with a country that has IBANs, have that country's length, be made of letters and digits, and pass the check of the two digits after the country (modulo 97). */
export function verifyIban(typed: string): string | null {
  const iban = typed.replace(/[\s-]/g, "").toUpperCase();
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]+$/.test(iban) || IBAN_LENGTHS[iban.slice(0, 2)] !== iban.length) return null;
  const moved = iban.slice(4) + iban.slice(0, 4);
  let rest = 0;
  for (const ch of moved) rest = (rest * (ch >= "A" ? 100 : 10) + (ch >= "A" ? ch.charCodeAt(0) - 55 : Number(ch))) % 97;
  return rest === 1 ? iban : null;
}
